import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Select,
  Switch,
  Button,
  Card,
  Row,
  Col,
  Modal,
  message,
  Checkbox,
  Popconfirm,
  Spin,
} from 'antd'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import styles from './BatchAddAccount.module.css'
import {
  addSchoolTeacherRequest,
  getXuekeListRequest,
} from './BatchAddAccountApi.js'
import { clearAllCookies } from '../../../../util/handleObject'
import Cookies from 'js-cookie'
import Step1 from './Step1.js'
import Step2 from './Step2.js'
import Step3 from './Step3.js'
import excelUtil from '../../../../util/excelUtil.js'
import excelUtilNew from '../../../../util/excelUtilNew.js'
import SuccessResult from './SuccessResult.js'
import ErrorResult from './ErrorResult.js'

const { TextArea } = Input
const BatchAddAccount = (props) => {
  const [step, setStep] = useState(1)
  const [accountList, setAccountList] = useState([]) // 原始账号列表
  const [xuekeList, setXuekeList] = useState([])
  const [gradeList, setGradeList] = useState([])
  const [newAccountList, setNewAccountList] = useState([]) // 导入到后台的账号列表
  const [errorList, setErrorList] = useState([1, 2, 3]) // 导入失败的账号列表
  const [isLoading, setIsLoading] = useState(false) // 导入状态

  useEffect(() => {
    getXuekeList()
    setStep(1)
  }, [props.openStatus]) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function getXuekeList() {
    getXuekeListRequest('', (data) => {
      if (data.ret == 1) {
        setGradeList(data.data.nianji_list)
        setXuekeList(data.data.xueke_list)
      } else if (data.ret == 99) {
        message.warning(data.msg)
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      }
    })
  }

  const closeCommon = () => {
    if (step == 4 || step == 5) {
      props.refresh()
    }
    props.closeMethod()
  }
  const importExcel = (file) => {
    excelUtilNew.importExcel(file, (data) => {
      let tempList = data.map((item, index) => {
        return {
          name: String(item.姓名),
          phone: String(item.手机号),
          points: String(item.积分限额),
          job: String(item.在校身份),
          grade: String(item.授课年级),
          index: index + 1,
        }
      })
      setAccountList(tempList)
      setStep(3)
    })
  }
  const importAccount = () => {
    console.log(accountList)
    setIsLoading(true)
    if (accountList.length == 0) {
      message.warning('请先导入账号')
      setIsLoading(false)
      return
    }
    // 校验账号是否重复
    let phoneSet = new Set()
    for (let item of accountList) {
      if (phoneSet.has(item.phone)) {
        message.warning(`第${item.index}行手机号重复`)
        setIsLoading(false)
        return
      }
      phoneSet.add(item.phone)

      if (
        !item.name ||
        item.name.trim() === '' ||
        item.name.trim() === 'undefined'
      ) {
        message.error(`第${item.index}行姓名不能为空`)
        setIsLoading(false)
        return
      }
      if (!/^1[3-9]\d{9}$/.test(item.phone.trim())) {
        message.error(`第${item.index}行手机号格式错误`)
        setIsLoading(false)
        return
      }
      if (!item.points || !/^(0|[1-9]\d*)$/.test(item.points.trim())) {
        message.error(`第${item.index}行积分格式错误`)
        setIsLoading(false)
        return
      }
      if (
        !item.job ||
        item.job.trim() === '' ||
        item.job.trim() === 'undefined'
      ) {
        message.error(`第${item.index}行在校身份格式错误`)
        setIsLoading(false)
        return
      }
      console.log(xuekeList)
      if (
        xuekeList.filter((xueke) => xueke.name == item.job).length != 0 &&
        item.job.trim() !== '其他' &&
        gradeList.filter((grade) => grade.name == item.grade).length == 0
      ) {
        message.error(`第${item.index}行在校身份应该选择相应年级`)
        setIsLoading(false)
        return
      }
      if (
        !item.grade ||
        item.grade.trim() === '' ||
        item.grade.trim() === 'undefined'
      ) {
        message.error(`第${item.index}行年级格式错误`)
        setIsLoading(false)
        return
      }
    }
    // 校验通过，设置新账号列表
    let tempList = accountList.map((item) => {
      let grade = {
        name: '',
        code: '',
      }
      let tempGradeList = gradeList.filter((grade) => grade.name == item.grade)
      if (tempGradeList.length != 0) {
        grade = tempGradeList[0]
      }

      let xueke = {
        name: '',
        code: '',
      }
      let tempXuekeList = xuekeList.filter((xueke) => xueke.name == item.job)
      if (tempXuekeList.length != 0) {
        xueke = tempXuekeList[0]
      }
      if (item.job.trim() === '班主任') {
        return {
          name: item.name,
          user_login: item.phone,
          pwd: '000000',
          jifen: item.points,
          status: '1',
          beizhu: '',
          shenfen_type: '2',
          nianji: item.grade,
          nianji_code: grade.code,
        }
      } else if (
        xuekeList.filter((xueke) => xueke.name == item.job).length == 0 ||
        item.job.trim() === '其他'
      ) {
        return {
          name: item.name,
          user_login: item.phone,
          pwd: '000000',
          jifen: item.points,
          status: '1',
          beizhu: '',
          shenfen_type: '3',
          nianji: item.grade,
          nianji_code: grade.code,
          qita_content: item.job,
        }
      } else {
        return {
          name: item.name,
          user_login: item.phone,
          pwd: '000000',
          jifen: item.points,
          status: '1',
          beizhu: '',
          shenfen_type: '1',
          nianji: item.grade,
          nianji_code: grade.code,
          xueke: item.job,
          xueke_code: xueke.code,
        }
      }
    })

    setNewAccountList(tempList)
    addSchoolTeacherRequest(JSON.stringify(tempList), (res) => {
      setIsLoading(false)
      if (res.ret == 1) {
        setStep(4)
      } else if (res.ret == 2) {
        setErrorList(res.data)
        setStep(5)
      } else {
        message.error(res.msg)
      }
    })
  }

  return (
    <Modal
      maskClosable={true}
      // visible={true}
      open={props.openStatus}
      onCancel={closeCommon}
      footer={null} // 设置 footer 为 null 移除默认按钮
      width={970}
      // className="add-account-container"
      title="批量账号导入"
    >
      {step == 1 ? (
        <Step1 nextStep={() => setStep(2)} />
      ) : step == 2 ? (
        <Step2
          prevStep={() => setStep(1)}
          nextStep={(file) => importExcel(file)}
        />
      ) : step == 3 ? (
        <Step3
          prevStep={() => setStep(2)}
          importAccount={() => importAccount()}
          accountList={accountList}
          deleteAccount={(item) => {
            console.log(item)
            setAccountList(accountList.filter((info) => info !== item))
          }}
        />
      ) : step == 4 ? (
        <SuccessResult
          prevStep={() => setStep(4)}
          closeMethod={() => {
            closeCommon()
            props.refresh()
          }}
          accountList={accountList}
        />
      ) : (
        <ErrorResult
          prevStep={() => setStep(4)}
          closeMethod={() => {
            closeCommon()
            props.refresh()
          }}
          totalNum={accountList.length}
          successNum={accountList.length - errorList.length}
          errorNum={errorList.length}
          errorList={errorList}
        />
      )}
      {isLoading ? (
        <Spin size="large" tip={"正在导入中..."} fullscreen={true} />
     ) : null} 
    </Modal>
  )
}

export default BatchAddAccount

